import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ANT DESIGN COMPONENTS
import { Empty } from "antd";
// COMPONENTS
import MonitoringLiftEscalatorFullView from "./MonitoringLiftEscalatorFullView";
// INTERFACES
import { BankInterface } from "../../../interfaces/Bank.interface";
import { LiftInterface } from "../../../interfaces/Lift.interface";

export default function MonitoringEscalatorsFullView({
  bank,
  serverId,
  channelId,
  enableActions,
}: {
  bank: BankInterface;
  serverId: string;
  channelId: string;
  enableActions: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div style={{ paddingBottom: "15px" }}>
      {/** ************************************************** */}
      {/** LIFTS */}
      {(bank.lifts ?? []).length === 0 ? (
        <>
          <Empty
            imageStyle={{ height: 40 }}
            description={<span>{t("edgeManagement.lifts.liftsNotAssigned")}</span>}
          />
        </>
      ) : (
        <div>
          <div className={` generalStyles__flex`} style={{ justifyContent: "center" }}>
            {(bank.lifts ?? [])
              .slice() // Create a shallow copy to avoid mutating the original array
              .sort((a: LiftInterface, b: LiftInterface) => {
                // Compare values based on a specific property (e.g., lift.name)
                if (a.position < b.position) return -1;
                if (a.position > b.position) return 1;
                return 0;
              })
              .map((lift: LiftInterface) => (
                <div key={String(lift.id ?? "")}>
                  <MonitoringLiftEscalatorFullView
                    lift={lift}
                    bank={bank}
                    serverId={serverId}
                    channelId={channelId}
                    enableActions={enableActions}
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
